// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3jSDF","messages":"Chat_messages__28If6","dateDivider":"Chat_dateDivider__SbrIq"};